import { render, staticRenderFns } from "./ChannelCmp.vue?vue&type=template&id=6eda01df&scoped=true&"
import script from "./ChannelCmp.vue?vue&type=script&lang=js&"
export * from "./ChannelCmp.vue?vue&type=script&lang=js&"
import style0 from "./ChannelCmp.vue?vue&type=style&index=0&id=6eda01df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eda01df",
  null
  
)

export default component.exports